export default __webpack_public_path__ + "img/96a13fed8b7401613100526823eb0439.svg";